import { useEffect, useState } from 'react';
import config from '@plone/volto/registry';
import { initClarity } from '../../helpers/clarity';

/**
 * AppExtra que obtiene el Project ID de Clarity desde el backend
 * (control panel) e inicializa Microsoft Clarity.
 */
export const ClarityAppExtra = () => {
  const [initialized, setInitialized] = useState(false);

  if (typeof window === 'undefined') {
    return null;
  }

  useEffect(() => {
    if (initialized) return;

    const tryFallback = () => {
      const fallback = (config.settings.clarityProjectId || '').trim();
      if (fallback) {
        initClarity(fallback);
        setInitialized(true);
      }
    };

    let apiPath = config.settings.apiPath || '';
    if (!apiPath.includes('/++api++')) {
      apiPath = apiPath.replace(/\/$/, '') + '/++api++';
    }
    const url = `${apiPath}/@clarity-settings`;

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          tryFallback();
          return null;
        }
        return res.json();
      })
      .then((data) => {
        if (data === null) return;
        if (!data || typeof data !== 'object') return tryFallback();
        const projectId = (data.project_id ?? '').trim();
        if (projectId) {
          initClarity(projectId);
          setInitialized(true);
        }
      })
      .catch(tryFallback);
  }, [initialized]);

  return null;
};
